function initLineup(lineup) {
  if (!lineup || lineup.dataset.ready) return;
  lineup.dataset.ready = 'true';
  const filters = lineup.querySelector('[data-filters]');
  const buttons = Array.from(filters.querySelectorAll('button'));
  const links = Array.from(lineup.querySelectorAll('[data-brand-link]'));
  const items = Array.from(lineup.querySelectorAll('[data-item]'));
  const empty = lineup.querySelector('[data-empty]');
  let brand = 'all';

  function show(department, requestedBrand) {
    brand = links.find((link) => link.dataset.brandLink === requestedBrand)?.dataset.brandLink || 'all';
    const choice = buttons.find((button) => button.dataset.filter === department) || buttons[0];
    buttons.forEach((button) => button.setAttribute('aria-pressed', String(button === choice)));
    links.forEach((link) => {
      if (link.dataset.brandLink === brand) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
      if (!link.hasAttribute('data-native-collection')) {
        const url = new URL(link.href);
        if (choice.dataset.filter === 'all') url.searchParams.delete('department');
        else url.searchParams.set('department', choice.dataset.filter);
        link.href = url.href;
      }
    });
    items.forEach((item) => {
      const matchesBrand = brand === 'all' || item.dataset.brand === brand;
      const matchesDepartment = choice.dataset.filter === 'all' || item.dataset.department === choice.dataset.filter;
      item.hidden = !(matchesBrand && matchesDepartment);
    });
    empty.hidden = items.some((item) => !item.hidden);
  }

  filters.addEventListener('click', (event) => {
    const button = event.target.closest('button[data-filter]');
    if (!button) return;
    const department = button.dataset.filter;
    show(department, brand);
    if (location.protocol !== 'file:') {
      const url = new URL(location.href);
      if (department === 'all') url.searchParams.delete('department');
      else url.searchParams.set('department', department);
      history.replaceState(history.state, '', url);
    }
  });
  const params = new URLSearchParams(location.search);
  show(params.get('department'), params.get('brand'));
  filters.hidden = false;
}

document.querySelectorAll('[data-lineup]').forEach(initLineup);
document.addEventListener('shopify:section:load', (event) => initLineup(event.target.querySelector('[data-lineup]')));
